import { render } from "./TheHeaderLarge.vue?vue&type=template&id=376e2a38&scoped=true"
import script from "./TheHeaderLarge.vue?vue&type=script&lang=ts"
export * from "./TheHeaderLarge.vue?vue&type=script&lang=ts"

import "./TheHeaderLarge.vue?vue&type=style&index=0&id=376e2a38&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-376e2a38"

export default script